import { Routes } from "@angular/router";
import { FaqComponent } from "../site-pages/faq/feature/faq.component";
import { AboutComponent } from "../site-pages/about/feature/about.component";
import { SitePagesComponent } from "../site-pages/feature/site-pages.component";
import { PreviewComponent } from "../core/preview/feature/preview.component";

export const aboutRoutes: Routes = [
     { path: 'about', data: {sidebar: false}, component: AboutComponent },
     { path: 'privacy', data: { pageContent: 'privacy', sidebar: false }, component:SitePagesComponent },
     { path: 'terms', data: { pageContent: 'terms', sidebar: false }, component: SitePagesComponent },
    { path: 'faq', data: { sidebar: false }, component: FaqComponent },
     { path: 'preview', data: { sidebar: false }, component: PreviewComponent}
    // {
    //     path: 'organsiers', children: [
    //         { path: 'register' }
    //     ]
    // },
    // {
    //     path: 'system/:id', children: [
    //         { path: 'terms' }
    //     ]
    // }
]